import { RouteConfig } from 'vue-router';
import howRegisterChildRoutes from '../../routes-children/how-register';
import localizationFactory from "@/router/modules/localization-factory";

export default {
	name: "",
	path: "/register",
	component: () => import('../../../layout/HowRegisterLayout.vue'),
	meta: localizationFactory('howRegister.header', {
		layout: "authorization",
		authRequired: false
	}),
	children: howRegisterChildRoutes
} as RouteConfig;